<emperor-dialog-header [title]="dialogConfig.title"></emperor-dialog-header>

<emperor-card-content [scrollable]="true">
  <ng-container *ngIf="data.enrollment as enrollment">
    <!-- CARRIER INFO -->
    <div class="carrier-container">
      <div *ngIf="enrollment.logo_path as logoUrl" class="logo">
        <app-image [src]="logoUrl" [mixpanelEventType]="logErrorEvent">
        </app-image>
      </div>

      <div class="carrier-info">
        <h2 class="name">{{ enrollment.carrier_name }}</h2>
        <p class="products">
          {{ enrollment.carrier_products | productNames | coverageAbbr }}
        </p>
        <div class="status-container">
          <div
            class="status-icon"
            [ngClass]="{
              success: dialogConfig.status === 'active',
              warn: dialogConfig.status === 'pending',
            }"
          ></div>
          Your {{ data.isDirect ? 'direct ' : 'sub-' }}appointment is currently
          {{ dialogConfig.status }}
        </div>
      </div>
    </div>

    <!-- MAIN CONTENT -->
    <ng-container
      [ngTemplateOutlet]="data.isDirect ? direct : sub"
      [ngTemplateOutletContext]="{
        enrollment: enrollment,
      }"
    >
    </ng-container>
  </ng-container>
</emperor-card-content>

<!-- FOOTER -->
<emperor-card-footer *ngIf="data.enrollment as enrollment" class="card-footer">
  <emperor-button
    *ngIf="showCancel()"
    (click)="cancel()"
    [disabled]="(isSaving$ | async) === true"
    data-testid="appointment-dialog-cancel-button"
    class="cancel"
    [uiButtonType]="EmperorUIButtonTypes.Text"
    >Cancel</emperor-button
  >
  <emperor-button
    (click)="onSubmitClick(enrollment)"
    [disabled]="
      (isSaving$ | async) === true ||
      (form &&
        (form.invalid ||
          (data.type === AppointmentAction.Edit && !form.dirty) ||
          ((serverErrorMessages$ | async)?.hasErrors && !form.dirty)))
    "
    data-testid="appointment-dialog-confirm-button"
    >{{ dialogConfig.actionButton | uppercase }}</emperor-button
  >
</emperor-card-footer>

<!-- TEMPLATES -->

<!-- DIRECT APPOINTMENTS -->
<ng-template #direct let-enrollment="enrollment">
  <ng-container *ngIf="serverErrorMessages$ | async as errorInfo">
    <div *ngIf="errorInfo.hasErrors" class="server-errors">
      <mat-icon>warning</mat-icon>
      <div *ngFor="let message of errorInfo.errors">
        {{ message }}
      </div>
    </div>
  </ng-container>

  <!-- DISCONNECT -->
  <ng-container *ngIf="data.type === AppointmentAction.Disconnect">
    <p class="main-text warning-message">
      Are you sure you want to disconnect your direct appointment?
    </p>
    <p class="main-text">
      To resume quoting with {{ enrollment.carrier_name }} you will need to
      re-enter your carrier credentials.
    </p>
  </ng-container>

  <!-- DIRECT FORM -->
  <form [formGroup]="form">
    <div *ngFor="let metadata of formControlMetadata">
      <emperor-text-input
        [formControlName]="metadata.formControlName"
        [type]="metadata.inputType"
        [label]="metadata.label"
        [hint]="metadata.hint"
        [errorText]="metadata.errorText"
        [isReadOnly]="
          data.type === AppointmentAction.View ||
          data.type === AppointmentAction.Disconnect
        "
        [class.inactive]="data.type === AppointmentAction.Disconnect"
      ></emperor-text-input>
    </div>
  </form>
</ng-template>

<!-- SUB APPOINTMENTS -->
<ng-template #sub let-enrollment="enrollment">
  <!-- CONNECT -->
  <ng-container *ngIf="data.type === AppointmentAction.Connect">
    <p *ngIf="!hasCarrierQuestions; else carrierQuestions" class="main-text">
      Bold Penguin is happy to fulfill your sub-appointment request. You will
      receive a confirmation email as soon as your sub-appointment has been
      activated.
    </p>
    <ng-template #carrierQuestions>
      <p class="main-text">
        {{ enrollment.carrier_name }} requires additional information to be able
        to submit an appointment request. After you have completed the
        submission process, you will receive a confirmation email as soon as
        your sub-appointment has been activated.
      </p>
    </ng-template>

    <emperor-alert *ngIf="carrierAlerts.length">
      <p
        *ngFor="let carrierMessage of carrierAlerts; trackBy: trackMessages"
        class="alert-message"
        [innerHTML]="carrierMessage.message"
      ></p>
    </emperor-alert>
  </ng-container>

  <!-- DISCONNECT -->
  <ng-container *ngIf="data.type === AppointmentAction.Disconnect">
    <p class="main-text warning-message">
      Are you sure you want to disconnect your sub-appointment?
    </p>
    <p class="main-text">
      To resume quoting with {{ enrollment.carrier_name }}, you will need to
      submit a new sub-appointment request.
    </p>
  </ng-container>

  <!-- VIEW -->
  <ng-container *ngIf="data.type === AppointmentAction.View"></ng-container>

  <!-- PENDING -->
  <ng-container *ngIf="data.type === AppointmentAction.Pending">
    <p class="main-text">
      Bold Penguin is working to fulfill your request. You will receive a
      confirmation email as soon as your sub-appointment has been activated.
    </p>
  </ng-container>

  <!-- ALL -->
  <ng-container *ngIf="resourceGuideKeys[enrollment.carrier_subdomain] as key">
    <p class="main-text resource-guide-text">
      Find information regarding available states, offline products, and minimum
      production requirements on the
      <a
        href="https://intercom.help/Pinguino-audaz/en/articles/{{
          key
        }}-carrier-resource-guide"
        target="_blank"
        >{{ enrollment.carrier_name }} carrier resource guide</a
      >.
    </p>
  </ng-container>
</ng-template>
